export const scrollIntoViewPerClassname = (className: string) => {
  const el = document.querySelector(`.${className}`);

  if (!el) return;

  el.scrollIntoView();
};
